// extracted by mini-css-extract-plugin
export default {"fileArea":"InputFile_fileArea__XZizn","fileDummy":"InputFile_fileDummy__Ly0QR","visuallyHidden":"InputFile_visuallyHidden__gwzLj","default":"InputFile_default__CNdcT"};